import { Routes, Route } from "react-router-dom";
import RequireAuth from "../Auth/RequireAuth";
import ErrorPage from "../components/common/VFX-UI/ErrorPage/ErrorPage";
import { IsOrganizationDonor, IsOrganizationUser, IsCauwUser } from "../utility/helpers/claimHelper";
import ReportsDashboard from "../components/Dashboard/ReportsDashboard";
import { OrganizationRoutes, SettingsRoutes, AuthRoutes, ReportsRoutes, CampaignRoutes } from ".";
import CampaignsContainer from "../components/Employee/Pledge/Campaign/CampaignContainer";

const AppRoutes = () => (
    <Routes>
        <Route
            path="/"
            element={
                <RequireAuth>
                    {IsOrganizationDonor() ? (
                        <CampaignsContainer activeCampaigns={true} />
                    ) : IsOrganizationUser() || IsCauwUser() ? (
                        <ReportsDashboard />
                    ) : null}
                </RequireAuth>
            }
        />
        {AuthRoutes}
        {SettingsRoutes}
        {OrganizationRoutes}
        {ReportsRoutes}
        {CampaignRoutes}
        <Route path="/error" element={<ErrorPage />} />
    </Routes>
);

export default AppRoutes;
